import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { GeoreferenceParentType } from '~/apollo/generated/v4/graphql';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { GeoreferenceManagerV4 } from '~/components/upload/georeference-v4/georeference-manager';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const GEOREFERENCES_PAGE = graphql(`
  query UploadStudyUpdateGeoreferencesPage($id: ID!) {
    studyGet(id: $id) {
      id
      georeferences {
        ...georeferenceParts
      }
    }
  }
`);

export default function UpdateStudyGeoreferencesPage() {
  return (
    <ApolloProviderV4>
      <UpdateStudyGeoreferencesPageInner />
    </ApolloProviderV4>
  );
}

function UpdateStudyGeoreferencesPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(GEOREFERENCES_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: GEOREFERENCES_PAGE,
      variables: { id: studyId },
    },
  ]);

  const study = data?.studyGet;
  const georeferences = study?.georeferences ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!study) return <NotFound />;

  return (
    <GeoreferenceManagerV4
      georeferences={georeferences}
      parentType={GeoreferenceParentType.Study}
      parentId={studyId}
      refetchQueries={refetchQueries}
    />
  );
}
